import type { Story } from '@/store/story-types'

export const CAFE_ORDER_APP_STORY: Story = {
  id: 'cafe-order-app',
  name: 'Bean & Brew — Cafe Ordering',
  narrative: 'A cafe ordering app with menu categories, item selection with add-to-cart, and order summary with total calculation.',
  goals: ['Browse menu categories', 'View individual menu items', 'Add items to order', 'Review order summary and place order'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-menu', title: 'Menu', order: 0, status: 'draft', elementCount: 4, linkedPageId: 'menu',
      description: 'Menu page with cafe header, category tabs, menu item grid, and footer',
      blockRef: { category: 'food', blockId: 'menu-categories' },
    },
    {
      id: 'pg-cart', title: 'Your Order', order: 1, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Order summary with item list, total calculation, and place order button',
      blockRef: { category: 'food', blockId: 'order-summary' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Menu',
      description: 'Customer browses the cafe menu by category',
      steps: [
        { type: 'given', text: 'the customer opens the cafe app' },
        { type: 'when', text: 'the menu page loads' },
        { type: 'then', text: 'menu categories and item cards with prices are visible', linkedPageId: 'menu' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Add Item to Order',
      description: 'Customer adds a menu item to their order',
      steps: [
        { type: 'given', text: 'the customer is browsing the menu', linkedPageId: 'menu' },
        { type: 'when', text: 'they tap the Add button on a menu item' },
        { type: 'then', text: 'the item is added to the order and the cart badge updates', linkedFlowId: 'addToCart' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Review Order Summary',
      description: 'Customer reviews their order before placing it',
      steps: [
        { type: 'given', text: 'the customer has items in the order' },
        { type: 'when', text: 'they navigate to the order summary page' },
        { type: 'then', text: 'the order summary shows all items, quantities, and total price', linkedPageId: 'cart' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Place Order',
      description: 'Customer places the order from the summary page',
      steps: [
        { type: 'given', text: 'the customer is on the order summary page', linkedPageId: 'cart' },
        { type: 'when', text: 'they tap the Place Order button' },
        { type: 'then', text: 'the order is submitted and a confirmation message is displayed', linkedFlowId: 'placeOrder' },
      ],
    },
  ],
}
